export function createDebounce(defaultDelayInMs: number = 300) {
  let timeout: NodeJS.Timeout
  return function (fnc: Function, delayInMs: number = defaultDelayInMs) {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      fnc()
    }, delayInMs)
  }
}
